const { makeStyles } = require('@material-ui/core')

const buttonBackHeaderStyles = makeStyles(theme => ({
  headerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(0.8),
  },
  iconButton: {
    backgroundColor: theme.palette.common.white,
  },
  button: {
    marginLeft: 'auto',
  },
}))

export default buttonBackHeaderStyles
